import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const light = document.querySelector('.p-recruit__light'),
  bulb = document.querySelector('.p-recruit__img--bulb__picture'),
  lightLeft = document.querySelector('.p-recruit__img__light--left__picture'),
  lightRight = document.querySelector('.p-recruit__img__light--right__picture')

if (light) {

  let lightTl = gsap.timeline({
    scrollTrigger: {
      scrub: 1,
      trigger: light,
      endTrigger: light,
      start: 'top 60%',
      end: () => '+=' + (light.clientHeight - 100),
      // markers: true,
    }
  })

  lightTl.addLabel('start')
    .from(bulb, { opacity: 0, top: 'calc(50% + 120px)'}, 0)
    .to(bulb, { opacity: 1, top: '50%'}, .5)

    .from(lightLeft, { opacity: 0, left: 'calc(50% + 64px)'}, 0)
    .to(lightLeft, { opacity: 1, left: '50%'}, .5)

    .from(lightRight, { opacity: 0, left: 'calc(50% - 64px)'}, 0)
    .to(lightRight, { opacity: 1, left: '50%'}, .5)

    .addLabel('end');
}